module.exports = __webpack_public_path__ + "static/img/抖音广告_04.f67f656.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/gdd102/抖音广告_04.jpg
// module id = agSI
// module chunks = 1